import { FilterType } from '@bedrock/eed-react/lib/components/ProFilter/interface';
import { IP_COPYRIGHT_OWNER_STATE } from '../../constants';

// IP 工作台筛选配置（PRD 5.1.1「支持所有列表字段可筛选」最小实现：所属产品 + 状态）：
//  - 所属产品：option 经 outsourceCommonFilterOptions(keys=['ip_cooperation_copyright_owner_products']) 拉取
//    （外包端 filter_options 白名单含 ip_cooperation_copyright_owner_products，版权方专属产品选项——
//     从当前版权方名下二级单产品清单去重，替代通用 'product'（按内部 user_belongs 过滤，版权方账号为空）；
//    searchKey 保持 'product' 提交给列表接口 product_ids 字段）
//  - 状态：外包端独立状态枚举 3 项（IP_COPYRIGHT_OWNER_STATE），与详情 state.code/列表「状态」列文案对齐，
//    noFetchOption 无需拉取；value 提交外包端枚举 code（OFFER_NEGOTIATING 由后端映射为 OFFER_NEGOTIATION+OFFER_NEGOTIATION_REVIEW 并集）
export const FILTER_OPTIONS = {
  filterKeys: [
    {
      searchKey: 'product',
      optionKey: 'ip_cooperation_copyright_owner_products',
      name: '所属产品',
    },
    {
      searchKey: 'states',
      name: '状态',
      noFetchOption: true,
      filterType: FilterType.SELECT_MULTIPLE,
      options: [
        { name: 'Offer谈判', value: IP_COPYRIGHT_OWNER_STATE.OFFER_NEGOTIATING },
        { name: 'Offer待确认', value: IP_COPYRIGHT_OWNER_STATE.OFFER_PENDING_CONFIRM },
        { name: 'Offer已确认', value: IP_COPYRIGHT_OWNER_STATE.OFFER_CONFIRMED },
      ],
    },
  ],
};
